var BlockView = require('views/block/base-block-view');
var FeedbackService = require('services/feedback-service');
var ContentProvider = require('services/content-provider');
import { KeybindingService, keys } from 'services/keybinding-service';

const { Enter } = keys;

var PollView = BlockView.extend({
  template: 'poll',
  load: function () {
    this.removeInputFromTabIndexing();
    this.poll = new EF.Models.Poll(
      _.pick(this.model.attributes, ['slug', 'answers', 'text', 'subtext', 'sectionIndex', 'questionIndex'])
    );
    this.model.set('translate', true);

    let multiple = this.model.get('multiple');
    let badgeType = this.model.get('badge_type');

    if (badgeType) {
      if (badgeType === 'numbers') {
        let badge = 1;
        _.each(this.poll.get('answers'), function (a) {
          a.badge_value = badge;
          badge++;
        });
      } else if (badgeType === 'letters') {
        let badge = 65;
        _.each(this.poll.get('answers'), function (a) {
          a.badge_value = String.fromCharCode(badge);
          badge++;
        });
      }
    }

    ContentProvider.PollService.renderPoll(this);

    this.delegate('click', '#question .inline_complete', e => {
      this.$(e.currentTarget).parent().addClass('clicked');
      if (!multiple) {
        this.save(this.$(e.currentTarget).parent().find('.user-supplied-text'));
      }
    });

    this.delegate('keyup', '#question .poll_answer .user-supplied-text', e => {
      const ele = this.$(e.currentTarget).next();
      if (ele.not(':visible')) {
        ele.show();
      }
    });

    if (multiple) {
      this.delegate('click', '#question .poll_complete', _e => {
        this.saveMany(this.$('#question .clicked').find('input'));
        this.readyToGo();
      });
    }

    this.delegate('click', '#question .poll_answer', e => {
      if (!this.$(e.currentTarget).find('.user-supplied-text').length) {
        this.$(e.currentTarget).addClass('clicked');
        if (!multiple) {
          this.save(this.$(e.currentTarget).find('input'));
        }
      }
    });
    this.delegate('focus', '#question .poll_answer', e => {
      if (this.$(e.currentTarget).find('.user-supplied-text').length) {
        this.undelegate('focus', '#question .poll_answer');
        this.$('.user-supplied-text', e.currentTarget).focus();
      }
    });
    this.delegate('keydown', '#question .poll_answer', e => {
      KeybindingService.with(e).bind(Enter, () => this.$(e.currentTarget).click());
    });
  },

  _setResponseData(response) {
    let total = [...response.totals].reduce((a, b) => a + b.count, 0);
    this.model.set('total', total);

    this.poll.get('answers').forEach(a => {
      let match = response.totals.find(r => {
        return r.id == a.id;
      });

      a.percent = match ? ((match.count / total) * 100) >> 0 : 0;
      a.count = match ? match.count : 0;
    });

    this.model.set('answers', this.poll.get('answers'));
    this.render();
  },

  saveMany: function (selectedAnswers) {
    let answerIds = Array.from(selectedAnswers).map(answer => $(answer).val());
    this.poll.set('response_id', answerIds);
    this.poll
      .save()
      .then(response => {
        if (!this.model.get('allow_change_answer')) {
          this.undelegate('click', '#question .poll_answer');
        }
        this.poll.get('answers').forEach(answer => {
          if (answerIds.includes(answer.id)) {
            answer.selected = true;
          }
        });
        if (response.totals) {
          this._setResponseData(response);
        }

        this.renderFeedback();
        this.removeInputFromTabIndexing();
      })
      .catch(this.readyToGo);
  },

  save: function (selectedAnswer) {
    var clickedAnswerId;
    var user_supplied_text = $(selectedAnswer).attr('type') === 'text' ? selectedAnswer.val() : null;
    this.poll.set('response_id', $(selectedAnswer).attr('id'));
    this.poll.set('user_supplied_text', user_supplied_text);

    this.poll
      .save()
      .then(response => {
        if (!this.model.get('allow_change_answer')) {
          this.undelegate('click', '#question .poll_answer');
        }
        this.poll.get('answers').forEach(answer => {
          answer.selected = false;
        });

        let answer = this.poll.get('answers').find(answer => answer.id === selectedAnswer.attr('id'));
        if (answer) {
          answer.selected = true;
          answer.user_supplied_text = user_supplied_text;
        }
        if (response.totals) {
          this.$('.poll_answer').each(function (_index) {
            if ($(this).hasClass('clicked')) {
              clickedAnswerId = $(this).find('input').attr('id');
            }
          });
          this._setResponseData(response);
        }
        this.renderFeedback();
        this.removeInputFromTabIndexing();

        setTimeout(() => {
          this.$(`#${clickedAnswerId}`).parent().focus();
        }, 500);

        this.readyToGo();
      })
      .catch(this.readyToGo);
  },

  renderFeedback: function () {
    if (this.model && this.model.get('feedback')) {
      FeedbackService.renderFeedbackWithElementState(this.model.get('feedback'), this.$el, 'passed', ['passed']);
    }
  },
  removeInputFromTabIndexing: function () {
    this.$('.poll_answer').find('input').attr('tabindex', '-1');
  },
});

module.exports = PollView;
